import _mixin from '../_mixin'
export default {
  name: 'SActivityWrap',
  cnName: '活动-公共弹窗部分',
  type: 'activity_common',
  preview: '',
  // 属性相关
  props: {
    modalBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/3e04e8eff75bf37e21385543de3c2124.png',
      style: {
        width: '750px',
        height: '620px'
      }
    },
    modalCloseIcon: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/a9525120a54aa4f2fd502a47c7e629b2.png',
      style: {
        width: '40px',
        height: '40px',
        right: '10px',
        top: '10px'
      }
    },
    modalTitleStyle: '{"padding": "30px 0"}',
    modalTextStyle: '{"color": "#50356D"}',
    modalConfirmBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/01/30/50471ebeffbabb3e7bfb7ba155f933bb.png)","color": "#50356D", "font-weight": "700"}',
    modalCancelBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/01/30/5f5077047474ed8a9fde19936a0dcd21.png)"}'
  },
  propsDesc: [
    {
      target: 'modalBg',
      label: '弹窗背景图',
      formType: 'image'
    },
    {
      target: 'modalCloseIcon',
      label: '关闭按钮',
      formType: 'image'
    },
    {
      target: 'modalTitleStyle',
      label: '标题样式',
      formType: 'textarea'
    },
    {
      target: 'modalTextStyle',
      label: '文本样式',
      formType: 'textarea'
    },
    {
      target: 'modalConfirmBtnStyle',
      label: '确认按钮样式',
      formType: 'textarea'
    },
    {
      target: 'modalCancelBtnStyle',
      label: '取消按钮样式',
      formType: 'textarea'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: []
}
